export default {
      ImportTypes: '$MHF_ModelNameVal_$MHF|ImportTypes',

};
